<template>
  <div>
    <div class="complete-container md:md-complete-container">
      <h2 class="title md:md-title">Thank you!</h2>
      <div class="grid grid-cols-1 md:grid-cols-6 gap-5 intro md:md-intro">
          <div class="md:col-span-3">
            <div class="grid gap-10">
              <div>
                Your contribution will help make people’s homes their Happy Place.
              </div>
              <div>
                For more information please contact studio@visualogical.co.uk
              </div>
            </div>
          </div>
        </div>
      <audio ref="aud" src="@/assets/audio/complete.mp3"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Complete',
  mounted() {
    this.$refs.aud.play();
  },
};
</script>

<style scoped>
.complete-container {
  margin: auto;
  margin-top: 50px;
  max-width: 90vw;
}

.intro {
  margin: 20px 0;
  text-align: left;
}

.title {
  color: #231f20;
  text-align: left;
}

@responsive {
  .md-intro {
    font-size: 2rem;
  }

  .md-complete-container {
    margin-top: 8vh;
    max-width: 70vw;
    text-align: left;
  }

  .md-title {
    font-size: 2.5rem;
  }
}
</style>
